import { auth } from "@/firebase";

export const getUserDefaultRecordId = () => {
  if (!auth.currentUser) throw new Error("User not authenticated.");
  return getUserOveridedId() || auth.currentUser.uid;
};

export const getUserOveridedId = () => {
  const overideId = window.location.search.split("did=")[1];
  if (!overideId) return null;
  console.log("Overided Id:", overideId);
  return overideId;
};
